import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  Output,
  booleanAttribute,
  forwardRef,
  numberAttribute,
} from '@angular/core'
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms'

interface BasinInputWithSelectorOutput {
  inputValue: number | string | undefined | null
  selectorValue: string | undefined | null
}

@Component({
  selector: 'basin-input-with-selector',
  templateUrl: './input-with-selector.component.html',
  styleUrls: ['./input-with-selector.component.scss'],
  providers: [
    // This registers the component as a NG_VALUE_ACCESSOR provider for form control.
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => InputWithSelectorComponent),
      multi: true,
    },
  ],
})
export class InputWithSelectorComponent implements ControlValueAccessor {
  @Input() ngModel: BasinInputWithSelectorOutput | undefined
  @Output() ngModelChange: EventEmitter<BasinInputWithSelectorOutput> =
    new EventEmitter<BasinInputWithSelectorOutput>()
  onModelChange: Function = () => {}
  onModelTouched: Function = () => {}
  constructor(public cd: ChangeDetectorRef) {}
  @Input({ transform: booleanAttribute }) updateOnBlurOnly: boolean = false
  @Input() inputType: string = 'number'
  @Input() inputLeftAddonText: string | undefined
  @Input() inputRightAddonText: string | undefined
  @Input() inputStyleClass: string | undefined
  @Input() inputId: string | undefined
  @Input() inputName: string | undefined
  @Input() inputPlaceholder: string | undefined
  @Input({ transform: numberAttribute }) inputMinlength: number | undefined
  @Input({ transform: numberAttribute }) inputMaxlength: number | undefined
  @Input({ transform: booleanAttribute }) inputReadonly: boolean | undefined
  @Input({ transform: booleanAttribute }) inputRequired: boolean | undefined
  @Input({ transform: booleanAttribute }) inputDisabled: boolean | undefined
  @Input() selectorOptions: any[] | undefined
  @Input() selectorOptionLabel: string | undefined
  @Input() selectorOptionValue: string | undefined
  @Input() selectorOptionDisabled: string | undefined
  @Input({ transform: booleanAttribute }) selectorUnselectable: boolean = false
  @Input({ transform: numberAttribute }) selectorTabindex: number = 0
  @Input({ transform: booleanAttribute }) selectorMultiple: boolean | undefined
  @Input({ transform: booleanAttribute }) selectorAllowEmpty: boolean = true
  @Input() selectorStyle: any
  @Input() selectorStyleClass: string | undefined
  @Input() selectorAriaLabelledBy: string | undefined
  @Input({ transform: booleanAttribute }) selectorDisabled: boolean | undefined
  @Input() selectorDataKey: string | undefined
  @Input({ transform: booleanAttribute }) selectorAutofocus: boolean | undefined
  @Output() onChange: EventEmitter<BasinInputWithSelectorOutput> =
    new EventEmitter<BasinInputWithSelectorOutput>()
  @Output() onFocus: EventEmitter<BasinInputWithSelectorOutput> =
    new EventEmitter<BasinInputWithSelectorOutput>()
  @Output() onBlur: EventEmitter<BasinInputWithSelectorOutput> =
    new EventEmitter<BasinInputWithSelectorOutput>()

  selectorValueChange($event: any) {
    this.ngModelChange.emit(this.ngModel)
    this.onModelChange(this.ngModel)
  }

  focus() {
    this.onFocus.emit(this.ngModel)
  }

  blur() {
    if (this.updateOnBlurOnly) {
      this.ngModelChange.emit(this.ngModel)
      this.onModelChange(this.ngModel)
    }
    this.onModelTouched()
    this.onBlur.emit(this.ngModel)
  }

  writeValue(obj: any): void {
    this.ngModel = obj
    this.cd.markForCheck()
  }
  registerOnChange(fn: any): void {
    this.onModelChange = fn
  }
  registerOnTouched(fn: any): void {
    this.onModelTouched = fn
  }

  setDisabledState?(isDisabled: boolean): void {
    this.selectorDisabled = isDisabled
    this.cd.markForCheck()
  }

  getInputBorderRadius(): string {
    if (this.inputRightAddonText && this.inputLeftAddonText) return 'no-radius'
    else if (!this.inputRightAddonText && this.inputLeftAddonText)
      return 'right-radius'
    else if (this.inputRightAddonText && !this.inputLeftAddonText)
      return 'left-radius'
    else return 'all-radius'
  }
}
